module.exports = __webpack_public_path__ + "static/media/tj.afcc0486.svg";